<template>
  <div>
    <el-form-item label-width="0">
      <el-divider class="custom-divider">{{ i18nt('designer.setting.uploadSetting') }}</el-divider>
    </el-form-item>
    <el-form-item :label="i18nt('designer.setting.uploadURL')">
      <el-input type="text" v-model="optionModel.uploadURL"></el-input>
    </el-form-item>
  </div>
</template>

<script>
import { toRefs } from 'vue';

import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';

export default {
  name: 'uploadURL-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const properyMixins = useProperty();

    return {
      i18nt,
      ...toRefs(props),
      ...properyMixins,
    };
  },
};
</script>

<style scoped></style>
